import { useEffect, useRef, useState } from "react";
import { WS_BASE } from "@/lib/api";

// Subscribe to live price ticks over WebSocket. Returns { PRICE_MAP, connected }.
// Resilient: silently no-ops if the socket cannot connect.
export default function useLivePrices(tickers) {
  const [prices, setPrices] = useState({});
  const [connected, setConnected] = useState(false);
  const wsRef = useRef(null);
  const key = (tickers || []).slice().sort().join(",");

  useEffect(() => {
    if (!key) { setPrices({}); return; }
    let closed = false;
    let retry;
    const connect = () => {
      try {
        const ws = new WebSocket(`${WS_BASE}/ws/prices?tickers=${encodeURIComponent(key)}`);
        wsRef.current = ws;
        ws.onopen = () => setConnected(true);
        ws.onmessage = (e) => {
          try {
            const msg = JSON.parse(e.data);
            if (msg.type === "prices") setPrices((p) => ({ ...p, ...msg.data }));
          } catch (_) {}
        };
        ws.onclose = () => {
          setConnected(false);
          if (!closed) retry = setTimeout(connect, 4000);
        };
        ws.onerror = () => { try { ws.close(); } catch (_) {} };
      } catch (_) { setConnected(false); }
    };
    connect();
    return () => { closed = true; clearTimeout(retry); try { wsRef.current?.close(); } catch (_) {} };
  }, [key]);

  return { prices, connected };
}
